(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require('./Common');

var _Common2 = _interopRequireDefault(_Common);

var _URLFormatter = require('./Common/URLFormatter');

var _URLFormatter2 = _interopRequireDefault(_URLFormatter);

var _EventDelegator = require('./EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

var _CommonClass2 = require('./Common/CommonClass');

var _CommonClass3 = _interopRequireDefault(_CommonClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APICore = function () {
	function APICore(url) {
		var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
		var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		_classCallCheck(this, APICore);

		url = '/api/v1/' + url;
		this._options = {
			url: url, method: method, data: data
		};
		this._csrfToken = document.querySelectorAll('input[name="_token"]')[0].getAttribute('value');
		this._setRequestHeaders = this.setRequestHeaders;
		this._setStatusFunctions = this.setStatusFunctions;
		this.request;
		this._eventName = '';
		_EventDelegator2.default.on('callAPI', this._call);
		return this;
	}

	_createClass(APICore, [{
		key: 'setStatusFunctions',
		value: function setStatusFunctions() {
			var that = this;
			if (!('failCallback' in this._options) || typeof this._options.failCallback !== 'function') {
				this._options.failCallback = function () {
					var callback = void 0;
					switch (that.request.status) {
						case 401:
							callback = function callback() {
								window.demo = true;
								window.needsToRegisterError('make modifications.');
								that.resetAPI('');
							};
							break;
						case 422:
						case 403:
							callback = function callback() {
								popUpMsg('Please contact your Committee Chairperson or Administrator to make modifications.');
								that.resetAPI('');
							};
							break;
						case 302:
						case 405:
							callback = function callback() {
								var url = that.request.responseText;
								var data = that.options.data;
								delete data['_method'];
								that.options = { url: '/api/v1/' + url, data: data };
								that.call(that.async);
							};
							break;
						default:
							callback = function callback() {
								window.unknownError();
								that.resetAPI('');
							};
							break;
					}
					if (that._eventName != '') {
						_EventDelegator2.default.on('ajaxFail' + ('.' + that._eventName), callback);
						_EventDelegator2.default.emit('ajaxFail' + ('.' + that._eventName), that.request);
					}
				};
			}
			if (!('doneCallback' in this._options) || typeof this._options.doneCallback !== 'function') {
				this._options.doneCallback = function () {
					if (that.request.status !== 200) {
						that._options.failCallback();
						return;
					}
					if (that._eventName != '') {
						_EventDelegator2.default.emit('ajaxSuccess' + ('.' + that._eventName), that.request);
					}
					that.resetAPI('');
				};
			}
			this.request.onreadystatechange = function () {};
			this.request.onload = this._options.doneCallback;
			this.request.onerror = this._options.failCallback;
		}
	}, {
		key: 'setRequestHeaders',
		value: function setRequestHeaders() {
			this.request.setRequestHeader('Accept', '*/*');
			this.request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			this.request.setRequestHeader('Accept-Language', 'en-US,en;q=0.8');
			this.request.setRequestHeader('Cache-Control', 'no-cache');
			this.request.setRequestHeader('Pragma', 'no-cache');
			this.request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			this.request.setRequestHeader('X-CSRF-Token', this._csrfToken);
			this.request.setRequestHeader('Authorization', window.apiToken);
		}
	}, {
		key: 'call',
		value: function call() {
			var async = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this.request = new XMLHttpRequest();
			var that = this;
			if (that._options.method === 'GET') {
				this.request.open(this._options.method.toUpperCase(), '' + this._options.url + this._options.sendData, async);
			} else {
				this.request.open(this._options.method.toUpperCase(), this._options.url, async);
			}
			this.request.withCredentials = true;
			this._setStatusFunctions();
			if (this._options.method === 'GET') {
				this._options.sendData = _URLFormatter2.default.formatGetObject(this._options.url, this._options.data);
				this._setRequestHeaders();
			} else {
				this._options.sendData = _URLFormatter2.default.objectToPostString(this._options.data);
				this._setRequestHeaders();
				this.request.send(this._options.sendData);
			}
			this.resetAPI();
		}
	}, {
		key: 'resetAPI',
		value: function resetAPI(url) {
			var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
			var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

			url = '/api/v1/' + url;
			var tmpOptions = { url: url, method: method, data: data };
			this.options = tmpOptions;
		}
	}, {
		key: 'options',
		get: function get() {
			return this._options;
		},
		set: function set(options) {
			for (var opt in options) {
				if (opt === 'url') {
					this._options[opt] = '/api/v1/' + options[opt];
				} else {
					this._options[opt] = options[opt];
				}
			}
		}
	}, {
		key: 'eventName',
		set: function set(eventName) {
			this._eventName = eventName;
		}
	}, {
		key: 'req',
		get: function get() {
			return this.request;
		}
	}]);

	return APICore;
}();

var APICoreV2 = function (_CommonClass) {
	_inherits(APICoreV2, _CommonClass);

	function APICoreV2(url) {
		var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

		var _ret;

		var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		_classCallCheck(this, APICoreV2);

		var _this = _possibleConstructorReturn(this, (APICoreV2.__proto__ || Object.getPrototypeOf(APICoreV2)).call(this));

		url = '/api/v1/' + url;
		_this._options = {
			url: url, method: method, data: data
		};
		_this._setRequestHeaders = _this.setRequestHeaders;
		_this.request;
		_this._eventName = '';
		_this._retry = 0;
		_this._async = true;
		_this._handleErrors = true;
		return _ret = _this, _possibleConstructorReturn(_this, _ret);
	}

	_createClass(APICoreV2, [{
		key: 'setRequestHeaders',
		value: function setRequestHeaders() {
			this.request.setRequestHeader('Accept', '*/*');
			this.request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			this.request.setRequestHeader('Accept-Language', 'en-US,en;q=0.8');
			this.request.setRequestHeader('Cache-Control', 'no-cache');
			this.request.setRequestHeader('Pragma', 'no-cache');
			this.request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
			this.request.setRequestHeader('X-CSRF-Token', this._csrfToken);
			this.request.setRequestHeader('Authorization', window.apiToken);
		}
	}, {
		key: 'call',
		value: function call() {
			var async = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._async = async;
			var that = this;
			return new Promise(function (resolve, reject) {
				that.request = new XMLHttpRequest();
				if (that._options.method === 'GET') {
					that._options.sendData = _URLFormatter2.default.formatGetObject(that._options.url, that._options.data);
					that.request.open(that._options.method.toUpperCase(), '' + that._options.sendData, that._async);
				} else {
					that.request.open(that._options.method.toUpperCase(), that._options.url, that._async);
				}
				that.request.withCredentials = true;
				that.request.onreadystatechange = function () {};
				that.request.onload = function () {
					if (that._retry >= 2) {
						reject({ message: 'retry', request: that.request });
					}
					switch (that.request.status) {
						case 200:
							resolve(JSON.parse(that.request.responseText));
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
						case 302:
						case 405:
							that._retry++;
							var url = that.request.responseText;
							var data = that.options.data;
							delete data['_method'];
							that.options = { url: '/api/v1/' + url, data: data };
							that.call(that._async);
							break;
						case 401:
							if (that.handleErrors) {
								that._error.showDemoError();
							}
							reject({ message: 'demo', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
						case 403:
							if (that.handleErrors) {
								that._error.privilegeError('make modifications.');
							}
							reject({ message: 'privilege', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
						case 204:
							reject({ message: 'no content', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
						case 404:
							reject({ message: 'not found', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
						case 500:
							if (that.handleErrors) {
								that._error.unknownError();
							}
							reject({ message: 'unknown', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
						default:
							if (that.handleErrors) {
								that._error.unknownError();
							}
							reject({ message: 'unknown', request: that.request });
							that.request = null;
							_EventDelegator2.default.emit('destroy', 'that');
							break;
					}
				}.bind(that);
				that.request.onerror = function () {
					that._promise.reject({ message: 'unknown', request: that.request });
				}.bind(that);
				if (that._options.method === 'GET') {
					that._options.sendData = _URLFormatter2.default.formatGetObject(that._options.url, that._options.data);
					that._setRequestHeaders();
					that.request.send();
				} else {
					that._options.sendData = _URLFormatter2.default.objectToPostString(that._options.data);
					that._setRequestHeaders();
					that.request.send(that._options.sendData);
				}
			});
		}
	}, {
		key: 'eventName',
		set: function set(eventName) {
			this._eventName = eventName;
		}
	}, {
		key: 'csrfToken',
		set: function set(token) {
			this._csrfToken = token;
		}
	}, {
		key: 'handleErrors',
		set: function set($yesno) {
			this._handleErrors = $yesno;
		}
	}]);

	return APICoreV2;
}(_CommonClass3.default);

var API = function (APICore) {
	var core = null,
	    subscribeToEvents = false,
	    resetAfterCall = true,
	    multipleCalls = false,
	    async = true,
	    handleErrors = true,
	    csrfToken = void 0;

	try {
		csrfToken = document.querySelectorAll('input[name="_token"]')[0].getAttribute('value');
	} catch (e) {}
	var call = function call(api, method) {
		var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var eventName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

		if (arguments.length < 2) throw new Error('Cannot make a call without the proper data'); //data is optional
		if (core === null) core = new APICore(api, method, data);else core.options = { url: api, method: method, data: data };
		core.eventName = eventName;
		core.call(async);
	};
	var setOptions = function setOptions(options) {
		//if you need to set deep options such as fail or success callbacks
		if (core === null) core = new APICore('');
		core.options = options;
	};
	var getOptions = function getOptions() {
		if (core === null) return false;
		return core.options;
	};
	var resetAPI = function resetAPI(option) {
		resetAfterCall = option;
	};
	var setAsync = function setAsync(asyncBool) {
		async = asyncBool;
	};
	var request = function request() {
		if (core === null) return false;
		return core.req;
	};
	var setMultipleCalls = function setMultipleCalls(set) {
		multipleCalls = set;
	};
	var setHandleErrors = function setHandleErrors(set) {
		handleErrors = set;
	};

	var handle = function handle(api, method) {
		var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var eventName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
		var async = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

		if (arguments.length < 2) throw new Error('Cannot make a call without the proper data'); //data is optional
		if (multipleCalls === false) {
			call(api, method, data, eventName);
			return false;
		}

		var newCore = new APICoreV2(api, method, data);
		newCore.eventName = eventName;
		newCore.csrfToken = csrfToken;
		newCore.handleErrors = handleErrors;
		return newCore.call(async);
	};

	return {
		core: core,
		subscribeToEvents: subscribeToEvents,
		call: call,
		setOptions: setOptions,
		getOptions: getOptions,
		resetAPI: resetAPI,
		request: request,
		setMultipleCalls: setMultipleCalls,
		setHandleErrors: setHandleErrors,
		handle: handle
	};
}(APICore);

module.exports = API;

},{"./Common":2,"./Common/CommonClass":3,"./Common/URLFormatter":10,"./EventDelegator":12}],2:[function(require,module,exports){
'use strict';

var _EventDelegator = require('./EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

var _PrototypeAddons = require('./Common/PrototypeAddons');

var _PrototypeAddons2 = _interopRequireDefault(_PrototypeAddons);

var _Functions = require('./Common/Functions');

var _Functions2 = _interopRequireDefault(_Functions);

var _Popup = require('./Common/Popup');

var _Popup2 = _interopRequireDefault(_Popup);

var _URLFormatter = require('./Common/URLFormatter');

var _URLFormatter2 = _interopRequireDefault(_URLFormatter);

var _CommonClass = require('./Common/CommonClass');

var _CommonClass2 = _interopRequireDefault(_CommonClass);

var _Data = require('./Common/Data');

var _Data2 = _interopRequireDefault(_Data);

var _Save = require('./Common/Save');

var _Save2 = _interopRequireDefault(_Save);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	URLFormatter: _URLFormatter2.default,
	Functions: _Functions2.default,
	CommonClass: _CommonClass2.default,
	Data: _Data2.default,
	Popup: _Popup2.default,
	Save: _Save2.default
};

},{"./Common/CommonClass":3,"./Common/Data":4,"./Common/Functions":5,"./Common/Popup":7,"./Common/PrototypeAddons":8,"./Common/Save":9,"./Common/URLFormatter":10,"./EventDelegator":12}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require('./../Common');

var _Common2 = _interopRequireDefault(_Common);

var _Popup = require('./Popup');

var _Popup2 = _interopRequireDefault(_Popup);

var _EventDelegator = require('./../EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommonClass = function () {
	function CommonClass() {
		_classCallCheck(this, CommonClass);

		this._error = this._initError();

		_EventDelegator2.default.on('popup.close', function (classObj) {
			classObj = null;
		});
		_EventDelegator2.default.on('destroy', function (classObj) {
			classObj = null;
		});
	}

	_createClass(CommonClass, [{
		key: '_initError',
		value: function _initError() {
			return {
				logError: function logError(log) {
					console.error(log);

					for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
						data[_key - 1] = arguments[_key];
					}

					if (data.length === 0) return;
					for (var i in data) {
						console.warn(data);
					}
				},
				unknownError: function unknownError() {
					var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'An unknown error has occurred.';

					new _Popup2.default('An unknown error has occurred.').showError();
				},
				showDemoError: function showDemoError() {
					var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'make modifications';

					error = 'Please <a href="/register">register</a> to ' + error;
					new _Popup2.default('An unknown error has occurred.').showError();
					window.demo = true;
				},
				privilegeError: function privilegeError() {
					var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'make changes.';

					error = 'Please contact your Committee Chairperson or Administrator to ' + error;
					new _Popup2.default(error).showError();
				}
			};
		}
	}]);

	return CommonClass;
}();

exports.default = CommonClass;

},{"./../Common":2,"./../EventDelegator":12,"./Popup":7}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require('./../Common');

var _Common2 = _interopRequireDefault(_Common);

var _CommonClass2 = require('./CommonClass');

var _CommonClass3 = _interopRequireDefault(_CommonClass2);

var _EventDelegator = require('./../EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

var _API = require('./../API');

var _API2 = _interopRequireDefault(_API);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Data = function (_CommonClass) {
	_inherits(Data, _CommonClass);

	function Data() {
		var initItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

		_classCallCheck(this, Data);

		var _this = _possibleConstructorReturn(this, (Data.__proto__ || Object.getPrototypeOf(Data)).call(this));

		_this._items = {};
		_this._dataFunction = function (value) {
			return {};
		};
		_this._throwWarnings = false;

		if (initItems !== false) {
			setRuntimeData(initItems);
		}
		return _this;
	}

	_createClass(Data, [{
		key: 'setRuntimeData',
		value: function setRuntimeData(data) {
			var removePassed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

			if (typeof data === 'Object') {
				var dataOld = _Common2.default.Functions.cloneObj(data);
				data = null;
				data = Object.keys(dataOld);
			}
			if (Array.isArray(data) === false) return this;
			if (this._items === undefined) this._items = {};
			for (var i = 0; i < data.length; i++) {
				this._items[data[i]] = this._dataFunction(data[i]);
				if (removePassed !== false) {
					data.splice(i, 1);
					i--;
				}
			}
			data = null;
			return this;
		}
	}, {
		key: 'setData',
		value: function setData(uid, data) {
			var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			if (this._dataExists(uid) === false) {
				this._error.logError('data with the index of ' + uid + ' does not exist', [data, index]);
				return this;
			}
			if (index !== false) this._items[uid][index] = data;else this._items[uid] = data;
			return this;
		}
	}, {
		key: 'getData',
		value: function getData(uid) {
			var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (this._dataExists(uid) === false && this._throwWarnings === true) {
				this._error.logError('data with the index of ' + uid + ' does not exist', []);
				return false;
			} else if (this._dataExists(uid) === false) {
				return false;
			} else {
				if (index !== false && index in this._items[uid]) return this._items[uid][index];else if (index !== false && !(index in this._items[uid])) return false;else return this._items[uid];
			}
		}
	}, {
		key: '_dataExists',
		value: function _dataExists(uid) {
			return uid in this._items ? true : false;
		}

		//getters

	}, {
		key: 'dataFunction',
		get: function get() {
			return this._dataFunction;
		},

		//setters
		set: function set(func) {
			this._dataFunction = func;
		}
	}, {
		key: 'throwWarnings',
		get: function get() {
			return this._throwWarnings;
		},
		set: function set(_set) {
			this._throwWarnings = _set;
		}
	}, {
		key: 'items',
		get: function get() {
			return this._items;
		}
	}]);

	return Data;
}(_CommonClass3.default);

exports.default = Data;

},{"./../API":1,"./../Common":2,"./../EventDelegator":12,"./CommonClass":3}],5:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var paddNumber = function paddNumber(num) {
	var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	padding -= num.toString().length;
	if (padding > 0) {
		return new Array(padding + (/\./.test(num) ? 2 : 1)).join('0') + num;
	}
	return num;
};
var overwriteObjectWithObject = function overwriteObjectWithObject(original, overwrite) {
	for (var key in overwrite) {
		original[key] = overwrite[key];
	}
	return original;
};
var getURLQueryObject = function getURLQueryObject(url) {
	return (url || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
		return n = n.split("="), this[n[0]] = n[1], this;
	}.bind({}))[0];
};
var addOrReplaceGetParameter = function addOrReplaceGetParameter(url, key, value) {
	var deleteKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	if (typeof url === "boolean") url = document.location.href;
	var checkParamRegex = new RegExp("[\\?&]" + key + "=([^&#]*)"),
	    match = checkParamRegex.exec(url),
	    delimiter = void 0,
	    newString = void 0,
	    hasQuestionMark = /\?/.test(url);
	if (match === null && !deleteKey) {
		delimiter = hasQuestionMark ? "&" : "?";
		newString = url + delimiter + key + "=" + value;
	} else if (deleteKey && match !== null) {
		delimiter = match[0].charAt(0);
		newString = url.replace(checkParamRegex, '');
		if (delimiter === '?' && newString.length >= match.index && newString.substr(match.index, 1) === '&') {
			newString = newString.replace(/&{1}/, '?');
		}
	} else if (!deleteKey) {
		delimiter = match[0].charAt(0);
		newString = url.replace(checkParamRegex, delimiter + key + "=" + value);
	}
	return newString;
};
var isEmpty = function isEmpty(elem) {
	var undefReturn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	switch (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) {
		case 'undefined':
			return undefReturn;
		case 'boolean':
			return elem;
		case 'function':
			try {
				var result = elem();
				return isEmpty(result);
			} catch (e) {
				return false;
			}
			return false;
		case 'number':
		case 'string':
			if (typeof elem === 'number' && elem === 0) return true;
			if (elem.length === 0 || elem.trim() === '') return true;
			return false;
		case 'object':
			if (elem === null) return true;
			if (Array.isArray(elem) && elem.length === 0) return true;
			if ($.isPlainObject(elem) && $.isEmptyObject(elem)) return true;
			return false;
		default:
			return false;
	}
};
var cloneOf = function cloneOf(item) {
	switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
		case 'object':
			return cloneObj(item);
		default:
			return item;
	}
};
var cloneObj = function cloneObj(object) {
	var clone = {};
	for (var key in object) {
		clone[key] = cloneOf(object[key]);
	}return clone;
};
var getObjectKeyValues = function getObjectKeyValues(object) {
	var ifInChildKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	var newObj = {};
	for (var key in object) {
		for (var childKey in object[key]) {
			if (ifInChildKey.length === 0) {
				newObj[childKey] = object[key][childKey];
			} else {
				var passes = false,
				    tmpChild = object[key][childKey];
				for (var i = 0; i < ifInChildKey.length; i++) {
					if (ifInChildKey[i] in tmpChild) {
						passes = true;
						tmpChild = tmpChild[ifInChildKey[i]];
					} else {
						passes = false;
					}
				}
				tmpChild = null;
				if (passes) newObj[childKey] = object[key][childKey];
			}
		}
	}
	return newObj;
};
var toWords = function toWords(n) {
	if (n == 0) return 'zero';
	var a = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
	var b = ['', '', 'twenty', 'thirty', 'fourty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
	var grp = function grp(n) {
		return ('000' + n).substr(-3);
	};
	var rem = function rem(n) {
		return n.substr(0, n.length - 3);
	};
	var fmt = function fmt(_ref) {
		var _ref2 = _slicedToArray(_ref, 3),
		    h = _ref2[0],
		    t = _ref2[1],
		    o = _ref2[2];

		return [Number(h) === 0 ? '' : a[h] + ' hundred ', Number(o) === 0 ? b[t] : b[t] && b[t] + '-' || '', a[t + o] || a[o]].join('');
	};
	var cons = function cons(xs) {
		return function (x) {
			return x ? [x, ' ', xs].join('') : xs;
		};
	};
	var iter = function iter(str) {
		return function (i) {
			return function (x) {
				return function (r) {
					if (x === '000' && r.length === 0) return str;
					return iter(cons(str)(fmt(x)))(i + 1)(grp(r))(rem(r));
				};
			};
		};
	};
	var num = iter('')(0)(grp(String(n)))(rem(String(n)));
	return num.substr(0, num.length - 1);
};
var isSS = function isSS() {
	if (window.is_surveyor) return true;else return false;
};
var makeList = function makeList(array) {
	var arrayStr = "";
	array.forEach(function (value, index) {
		arrayStr = arrayStr + value + '\n';
	});
	return arrayStr;
};
var capitalizeString = function capitalizeString(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
};
var isJson = function isJson(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};
var showLoading = function showLoading(msg) {
	var pop = $('<div class="popwrap"><div class="pop_up tan text-center"><p style="text-align:center;font-size:125%;">' + msg + '<div></div>').prependTo('body');
	pop.append('<div class="overlay"></div>');
	return pop;
};
var localStoreSupport = function localStoreSupport() {
	var testKey = 'test',
	    storage = window.sessionStorage;
	try {
		storage.setItem(testKey, '1');
		storage.removeItem(testKey);
		return true;
	} catch (error) {
		return false;
	}
};

var workerSupport = function workerSupport() {
	if (typeof window.Worker !== "undefined") return true;else return false;
};

var isFunction = function isFunction(obj) {
	return typeof obj == 'function' || false;
};

module.exports = {
	paddNumber: paddNumber,
	overwriteObjectWithObject: overwriteObjectWithObject,
	getURLQueryObject: getURLQueryObject,
	addOrReplaceGetParameter: addOrReplaceGetParameter,
	isEmpty: isEmpty,
	cloneObj: cloneObj,
	getObjectKeyValues: getObjectKeyValues,
	toWords: toWords,
	capitalizeString: capitalizeString,
	isSS: isSS,
	makeList: makeList,
	isJson: isJson,
	showLoading: showLoading,
	localStoreSupport: localStoreSupport,
	workerSupport: workerSupport,
	isFunction: isFunction
};

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var months = {
		'January': 1,
		'February': 2,
		'March': 3,
		'April': 4,
		'May': 5,
		'June': 6,
		'July': 7,
		'August': 8,
		'September': 9,
		'October': 10,
		'November': 11,
		'December': 12
	};

	function getMonthNumberByName(name) {
		if (name in months) {
			return months[name];
		} else {
			throw new Error('Month name ' + name + ' not in the month set');
			return false;
		}
	}

	return {
		getMonthNumberByName: getMonthNumberByName
	};
}();

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Functions = require('./Functions');

var _Functions2 = _interopRequireDefault(_Functions);

var _EventDelegator = require('./../EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Popup = function () {
	function Popup(html) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Popup);

		if (html === undefined) throw new Error('Must pass HTML/Text to a popup');
		this.htmlCheckRegex = new RegExp(/<[^br][a-z][\s\S]*>/i);
		this.$html = html;
		this._isError = false;
		this.options = {
			$appendTo: $('body'),
			overlay: true,
			class: false,
			closeTopRight: true,
			callbacks: {},
			tan: true,
			custom: {
				imagePopupHTML: '',
				offsetY: false,
				scroll: false,
				bodyClass: false,
				outsideScroll: false,
				buttons: false
			}
		};
		this.options = _Functions2.default.overwriteObjectWithObject(this.options, options);
		this._customData = {};
		return this;
	}

	//options


	_createClass(Popup, [{
		key: '_runOptions',
		value: function _runOptions() {
			var _this = this;

			var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
			//not all cases need to use the on parameter
			var defaultTypes = ['offsetY', 'scroll', 'buttons'];
			var customTypes = {
				scroll: {
					true: function _true(on) {
						_this.$popup.wrapInner('<div class="scroll"></div>');
						_this._setDefault('scroll', on);
					}
				},
				buttons: {
					closeAndSave: function closeAndSave(on) {
						_this.$popup.append('<button id="cancelButton">Cancel</button> <button id="saveButton">SAVE</button>');
						var saveFunction = function saveFunction() {
							_EventDelegator2.default.emit('Popup.save', _this._customData);
							_this._removePopup();
						};
						saveFunction.bind(_this);
						$('#saveButton').click(saveFunction);
					}
				}
			};
			for (var option in this.options.custom) {
				if (this.options.custom[option] === false) continue;
				if (typeof this.options.custom[option] === 'function') {
					this.options.custom[option].bind(this.$popup)(on);
				} else if (defaultTypes.indexOf(option) > -1 && this.options.custom[option] === 'default') {
					this._setDefault(option, on);
				} else if (defaultTypes.indexOf(option) > -1 && this.options.custom[option] !== 'default' && option in customTypes && this.options.custom[option.toString()] in customTypes[option]) {
					customTypes[option][this.options.custom[option.toString()]](on);
				} else {
					switch (option) {
						case 'bodyClass':
							if (on) $('body').addClass(this.options.custom[option]);else $('body').removeClass(this.options.custom[option]);
							break;
						case 'scroll':
							if (option in customTypes && this.options.custom[option.toString()] in customTypes[option]) customTypes[option][this.options.custom[option.toString()]](on);else throw new Error('The function ' + this.options.custom[option.toString()] + ' does not exist for ' + option);
							break;
						case 'outsideScroll':
							if (this.options.custom.scroll !== 'default') this.$popup.find('.scroll').insertAfter(this.options.custom[option]);
							break;
						case 'buttons':
							this.$popup.append(this.options.custom[option]);
							break;
					}
				}
			}
		}
	}, {
		key: '_setDefault',
		value: function _setDefault(name, on) {
			switch (name) {
				case 'offsetY':
					this.$popup.css('top', '2.5%');
					break;
				case 'scroll':
					if (on) {
						$('body').addClass('noscroll');
					} else {
						$('body').removeClass('noscroll');
					}
					break;
				case 'buttons':
					this.$popup.append('<button id="closeButton">Close</button>');
					break;
			}
		}

		//callbacks

	}, {
		key: 'setCallback',
		value: function setCallback(name, func) {
			this.options.callbacks[name] = func;
		}
	}, {
		key: '_defaultCallbacks',
		value: function _defaultCallbacks() {
			if (this.options.closeTopRight || this.$popup.find('#closeButton').length !== 0) {
				var that = this;
				this.normalCloseFunction = function (e) {
					e.preventDefault();
					that._callback('close');
					that.$popup.add(that.$overlay).remove();
					that._runOptions(false);
					that._callback('remove', that);
				};
				this.normalCloseFunction.bind(this);
				$('#msgClose, #closeButton').click(this.normalCloseFunction);
			}
		}
	}, {
		key: '_callback',
		value: function _callback(name, data) {
			if (name in this.options.callbacks) {
				if (data === undefined) _EventDelegator2.default.emit('popup.' + name);else _EventDelegator2.default.emit('popup.' + name, data);
			}
		}
	}, {
		key: '_removePopup',
		value: function _removePopup() {
			this._callback('close');
			$('#msgClose, #closeButton').unbind('click');
			if (this.$overlay !== undefined) this.$popup.add(this.$overlay).remove();else if (this.$popup !== undefined) this.$popup.remove();
			this._callback('remove', this);
		}
	}, {
		key: '_createPopup',
		value: function _createPopup() {
			this.$popup = $('<div class="pop_up' + (this.options.tan === true ? ' tan' : '') + '"></div>');
			if (this.options.class !== false && typeof this.options.class === "string") {
				this.$popup.addClass(this.options.class);
			}
			if (this.htmlCheckRegex.test(this.$html) === false) {
				this.$html = $('<p style="text-align:' + (!this._isError ? 'left' : 'center') + '; font-size:125%;">' + (this.options.closeTopRight ? '<i id="msgClose" class="icon-cancel-circled" data-icon="i" style="float:right;margin:0 0 0 10px;font-size:26px;max-height:26px;overflow:hidden"></i>' : '') + this.$html + '</p>');
			}

			this.$popup.html(this.$html);
			this.$popup.prependTo(this.options.$appendTo);
		}
	}, {
		key: '_createOverlay',
		value: function _createOverlay() {
			this.$overlay = $('<div class="overlay"></div>');
			this.$overlay.insertAfter(this.$popup);
		}
	}, {
		key: 'show',
		value: function show() {
			var that = this;
			return new Promise(function (resolve, reject) {
				that._removePopup();
				that._createPopup();
				if (that.options.overlay) {
					that._createOverlay();
				}
				that._runOptions();
				that._defaultCallbacks();
				for (var name in that.options.callbacks) {
					that.options.callbacks[name].bind(that);
				}
				resolve(that);
			});
		}
	}, {
		key: 'remove',
		value: function remove() {
			this._removePopup();
			this._runOptions(false);
			this._callback('close');
			this._callback('remove', this);
		}
	}, {
		key: 'showError',
		value: function showError() {
			self._isError = true;
			this.show();
			return this;
		}
	}, {
		key: 'createThumbs',
		value: function createThumbs() {
			var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var insertAfter = arguments[1];
			var row = arguments[2];

			this.updateCustomData('images', images);
			this.updateCustomData('task_uid', row);
			var thumbsHTML = '<div id="thumbWrap"><div class="thumbs"><ul class="thumbs-slider">';
			thumbsHTML += this.createThumbHTML();
			thumbsHTML += '</ul></div></div><div class="clearfix"></div>';
			var $thumbs = $(thumbsHTML).insertAfter(this.$popup.find('#' + insertAfter));

			this.updateCustomData('thumbs', $thumbs);
			this.updateThumbSlider(images);
		}
	}, {
		key: 'updateThumbSlider',
		value: function updateThumbSlider() {
			var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var isNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			var $thumbs = this._customData['thumbs'],
			    newImageIndex = images ? images.length - 1 : '',
			    newImage = newImageIndex ? images[newImageIndex] : '',
			    newImageHTML = '',
			    newThumbsHTML = '',
			    thumbsHTML = $thumbs.html(),
			    that = this;

			if (isNew) newImageHTML = '<li><a href="#" id="' + newImage.meta + '" data-index="' + newImageIndex + '" data-row="' + row + '" data-meta="' + newImage.meta + '" data-cropped-id="' + newImage.cropped_id + '"><img height="50" src="' + newImage.cropped + '" /><span class="sampleName">' + (newImage.sample != "" ? newImage.sample : '') + '</span></a></li>';
			$thumbs.find('.thumbs-slider').append(newImageHTML);

			if (images.length > 0) this.updateCustomData('images', images);
			this.updateCustomData('thumbs', $thumbs);

			if (images.length <= 10) {
				$('.dep_toggle').remove();
				$thumbs.find('.thumbs').addClass('noslider').removeClass('slider');
				$thumbs.find('.thumbs-slider li').width($thumbs.find('.thumbs-slider').width() / images.length);
				var noslider = $('a .noslider-wrap');
				if (noslider.length == 0) $thumbs.find('a').wrapInner('<div class="noslider-wrap"></div>');
			} else {
				$thumbs.find('.thumbs').addClass('slider').removeClass('noslider');
				var slider = $thumbs.find('.thumbs-slider').lightSlider({
					item: 10,
					pager: false,
					prevHtml: '<span data-icon="L" class="icon dep_toggle prev_dep pointer"></span>',
					nextHtml: '<span data-icon="R" class="icon dep_toggle next_dep pointer"></span>'
				});
				slider.refresh();
				this.updateCustomData('slider', slider);
			}
			$thumbs.find('li img').each(function (index, el) {
				$(el).load(function () {
					$(el).siblings('span').width($(el).width());
				});
			});

			$thumbs.find('li a').off('click').click(function (event) {
				event.preventDefault();
				that.createImagePopup(that.options.custom['imagePopupHTML'], $(this).data('index'), $(this).data('row'), $(this).data('meta'), $(this).data('cropped-id'));
			});
		}
	}, {
		key: 'createImagePopup',
		value: function createImagePopup(html, index, row, meta, cropped_id) {
			var $html = $(html),
			    image = this._customData['images'][index],
			    that = this;

			$html.find('#originalsizeimage').attr('src', image.cropped);
			$html.find('#metaData').attr('data-row', row);
			$html.find('#metaData').attr('data-index', index);
			$html.find('#metaData').attr('data-meta', meta);
			$html.find('#metaData').attr('data-cropped-id', cropped_id);
			$html.find('#samplePersonSelect').val(image.sample);
			$html.find('#imgTitle').val(image.title);
			$html.find('#imgDescription').val(image.description);

			$('.pop_up').append($html);

			$('#deleteImageButton').click(function (event) {
				var metaId = $('#metaData').attr('data-meta'),
				    cropped_id = $('#metaData').attr('data-cropped-id');
				that.deleteImage(index, metaId, cropped_id);
			});
			$('#saveImageDetailsButton').click(function (event) {
				var title = $('#imgTitle').val(),
				    description = $('#imgDescription').val(),
				    sample = $('#samplePersonSelect').val(),
				    metaId = $('#metaData').attr('data-meta'),
				    cropped_id = $('#metaData').attr('data-cropped-id');

				that._customData['images'][index]['sample'] = sample;
				that._customData['images'][index]['title'] = title;
				that._customData['images'][index]['description'] = description;

				$('#' + metaId).find('.sampleName').text(sample);

				that.updateImage(title, description, sample, metaId, cropped_id);
				$('.imageBox').remove();
				$('.overlay-img').remove();
			});
			$(".imageBox").draggable({ cancel: 'input, button, textarea, select, option' });
		}
	}, {
		key: 'deleteImage',
		value: function deleteImage(index, metaId, cropped_id) {
			var that = this;
			$('#deleteDialog').dialog({
				height: 140,
				draggable: false,
				resizable: false,
				appendTo: '.imageBox',
				buttons: {
					No: function No() {
						$(this).dialog("close");
						$(this).dialog("destroy");
					},
					Yes: function Yes() {
						$.post('/files/delete-image', { meta_id: metaId, cropped_id: cropped_id }, function (data) {
							if (data.status == 'error') {
								alert('Something went wrong!');
							} else {
								that._customData['images'].splice(index, 1);
								$('.imageBox').remove();
								$('.overlay-img').remove();
								that.removeThumb(metaId);
							}
						});
						$(this).dialog("close");
						$('.imageBox, .overlay-img').fadeOut(300, function () {
							$('.imageBox, #deleteDialog, .overlay-img').remove();
						});
						$(this).dialog("destroy");
					}
				}
			});
			$('.ui-dialog-buttonset button, .ui-dialog-buttonset button > span').removeClass().attr('role', '').attr('aria-disabled', '');
		}
	}, {
		key: 'removeThumb',
		value: function removeThumb(metaId) {
			var $thumbs = this._customData['thumbs'],
			    images = this._customData['images'],
			    thumbsHTML = this.createThumbHTML();

			$thumbs.find('.thumbs-slider').empty();
			$thumbs.find('.thumbs-slider').append(thumbsHTML);
			this.updateCustomData('thumbs', $thumbs);
			this.updateThumbSlider(images);
		}
	}, {
		key: 'createThumbHTML',
		value: function createThumbHTML() {
			var images = this._customData['images'],
			    row = this._customData['task_uid'],
			    thumbsHTML = '';

			images.forEach(function (v, index) {
				thumbsHTML += '<li><a href="#" id="' + v.meta + '" data-index="' + index + '" data-row="' + row + '" data-meta="' + v.meta + '" data-cropped-id="' + v.cropped_id + '"><img height="50" src="' + v.cropped + '" /><span class="sampleName">' + (v.sample != "" ? v.sample : '') + '</span></a></li>';
			});
			return thumbsHTML;
		}
	}, {
		key: 'updateImage',
		value: function updateImage(title, description, sample, metaId, cropped_id) {

			$('.thumbs-slider a[data-meta="' + metaId + '"]').attr('data-index', sample);
			$.post('/files/update-image', { title: title, description: description, sample: sample, meta_id: metaId, cropped_id: cropped_id }, function (data) {
				if (data.status == 'error') {
					console.log(error);
				}
			});
		}
	}, {
		key: 'updateCustomData',
		value: function updateCustomData(key, value) {
			this._customData[key] = value;
			return this;
		}
	}, {
		key: 'getOptions',
		get: function get() {
			return this.options;
		}
	}, {
		key: 'customData',
		get: function get() {
			return this._customData;
		},
		set: function set(data) {
			this._customData = data;
			return this;
		}
	}, {
		key: 'isError',
		set: function set(opt) {
			this._isError = opt;
			return this;
		}
	}]);

	return Popup;
}();

exports.default = Popup;

},{"./../EventDelegator":12,"./Functions":5}],8:[function(require,module,exports){
"use strict";

String.prototype.contains = function (str) {
  return this.indexOf(str) != -1;
};
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

String.prototype.replaceAllRegExp = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require('./../Common');

var _Common2 = _interopRequireDefault(_Common);

var _CommonClass2 = require('./CommonClass');

var _CommonClass3 = _interopRequireDefault(_CommonClass2);

var _EventDelegator = require('./../EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

var _API = require('./../API');

var _API2 = _interopRequireDefault(_API);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Save = function (_CommonClass) {
	_inherits(Save, _CommonClass);

	function Save() {
		_classCallCheck(this, Save);

		var _this = _possibleConstructorReturn(this, (Save.__proto__ || Object.getPrototypeOf(Save)).call(this));

		_this._url;
		_this._method = 'POST';
		_this._async = true;
		_this._max = 5;
		_this._staging = [];
		_this._promise = false;
		return _this;
	}

	_createClass(Save, [{
		key: 'save',
		value: function save(data) {
			if (this._promise === true) {
				_API2.default.setMultipleCalls(true);
				var that = this;
				return new Promise(function (resolve, reject) {
					_API2.default.handle(that._url, that._method, data, 'save', true).then(function (success) {
						return resolve(success);
					}).catch(function (error) {
						return reject(error);
					});
				});
			} else {
				_API2.default.call(this._url, this._method, data, 'save');
			}
		}
	}, {
		key: 'fetch',
		value: function fetch(data) {
			return this.save(data);
		}

		//setters

	}, {
		key: 'max',
		set: function set(max) {
			this._max = max;
		},

		//getters
		get: function get() {
			return this._max;
		}
	}, {
		key: 'url',
		set: function set(url) {
			this._url = url;
		},
		get: function get() {
			return this._url;
		}
	}, {
		key: 'method',
		set: function set(method) {
			this._method = method;
		},
		get: function get() {
			return this._method;
		}
	}, {
		key: 'async',
		set: function set() {
			var _set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			this._async = _set;
		},
		get: function get() {
			return this._async;
		}
	}, {
		key: 'promise',
		set: function set() {
			var _set2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			this._promise = _set2;
		},
		get: function get() {
			return this._promise;
		}
	}]);

	return Save;
}(_CommonClass3.default);

exports.default = Save;

},{"./../API":1,"./../Common":2,"./../EventDelegator":12,"./CommonClass":3}],10:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Months = require('./Months');

var _Months2 = _interopRequireDefault(_Months);

var _Functions = require('./Functions');

var _Functions2 = _interopRequireDefault(_Functions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URLFormatter = function (Months) {
	var formatGetObject = function formatGetObject() {
		var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
		var data = arguments[1];

		if (Object.keys(data).length == 0) return url;
		var hasParameters = url.contains('?') ? true : false;
		if (hasParameters) {
			var currentGetObject = _Functions2.default.getURLQueryObject();
			for (var key in currentGetObject) {
				if (key in data) url = _Functions2.default.addOrReplaceGetParameter(url, key, false, true);
			}
			hasParameters = url.contains('?') ? true : false;
		}
		var append = '';
		for (var param in data) {
			if (append === '' && hasParameters === false) {
				append += '?';
				hasParameters = true;
			} else append += '&';
			append += param + '=' + data[param];
		}
		return url + append;
	};

	var objectToPostString = function objectToPostString(data, prefix) {
		var str = [];
		for (var p in data) {
			if (data.hasOwnProperty(p)) {
				var k = prefix ? prefix + '[]' : p,
				    v = data[p];
				str.push((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? objectToPostString(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
			}
		}
		return str.join('&');
	};

	var formatDatePicker = function formatDatePicker(dateString) {
		dateString = dateString.replace(",", "");
		var date = dateString.split(' ');
		return date[2] + '-' + _Functions2.default.paddNumber(Months.getMonthNumberByName(date[0])) + '-' + _Functions2.default.paddNumber(date[1]);
	};

	return {
		formatGetObject: formatGetObject,
		objectToPostString: objectToPostString,
		formatDatePicker: formatDatePicker
	};
}(_Months2.default);
module.exports = URLFormatter;

},{"./Functions":5,"./Months":6}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Functions = require('./Common/Functions');

var _Functions2 = _interopRequireDefault(_Functions);

var _EventDelegator = require('./EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatePicker = function () {
	function DatePicker(selector) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DatePicker);

		var that = this;
		this.selector = selector;
		this._avalibleDates = [];
		this.$currentPicker;
		this.options = {
			useEventDelegator: false,
			datepicker: {
				dateFormat: 'mm/dd/yy',
				buttonImageOnly: true,
				stepMonths: 0,
				changeMonth: false,
				changeYear: false,
				beforeShowDay: function beforeShowDay(date) {
					if ($.inArray($.datepicker.formatDate('mm/dd/yy', date), that._avalibleDates) > -1) {
						return [true, ""];
					} else {
						return [false, ""];
					}
				},
				onSelect: function onSelect(date, dateObj) {
					if (that.options.useEventDelegator) {
						_EventDelegator2.default.emit('DatePicker.onSelect', { date: date, dateObj: dateObj });
						return;
					} else {
						if ('onSelect' in that.callbacks) {
							that.callbacks['onSelect']({ date: date, dateObj: dateObj });
						} else {
							throw new Error('You do not have an event set for onSelect');
						}
					}
				}
			},
			callbacks: {}
		};
		this.options = _Functions2.default.overwriteObjectWithObject(this.options, options);
		this._init();
	}

	_createClass(DatePicker, [{
		key: '_init',
		value: function _init() {
			var that = this;
			$(document).on('click', this.selector, function (e) {
				e.preventDefault();
				that.$currentPicker = $(this).siblings('input.datepicker');
				$(this).siblings('input.datepicker').datepicker(that.options.datepicker);
				if (that.options.useEventDelegator) {
					_EventDelegator2.default.emit('DatePicker.click', $(this).siblings('input.datepicker'));
				} else {
					if ('click' in that.callbacks) {
						that.callbacks['click'](date, dateObj);
					} else {
						$(this).datepicker('setDate', that._avalibleDates[0]);
						$(".ui-datepicker-prev, .ui-datepicker-next").remove();
						$(this).datepicker('show');
					}
				}
				return false;
			});
		}
	}, {
		key: 'avalibleDates',
		get: function get() {
			return this._avalibleDates;
		},
		set: function set(dates) {
			this._avalibleDates = dates;
		}
	}]);

	return DatePicker;
}();

exports.default = DatePicker;

},{"./Common/Functions":5,"./EventDelegator":12}],12:[function(require,module,exports){
"use strict";

var EventDelegator = {
	events: {},
	on: function on(eventName, fn) {
		EventDelegator.events[eventName] = EventDelegator.events[eventName] || [];
		EventDelegator.events[eventName].push(fn);
	},
	off: function off(eventName) {
		var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		if (EventDelegator.events[eventName]) {
			if (fn === false) {
				EventDelegator.events[eventName] = null;
				delete EventDelegator.events[eventName];
				return;
			}
			for (var i = 0; i < EventDelegator.events[eventName].length; i++) {
				if (EventDelegator.events[eventName][i] === fn) {
					EventDelegator.events[eventName].splice(i, 1);
					break;
				}
			}
		}
	},
	emit: function emit(eventName) {
		var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var noBubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		if (EventDelegator.events[eventName]) {
			var functions = EventDelegator.events[eventName],
			    called = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = functions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var fn = _step.value;

					if (noBubble && called.indexOf(fn) !== -1) {
						continue;
					}
					if (fn === undefined) continue;
					if (noBubble) called.push(fn);
					data == null ? fn() : fn(data);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}
};
module.exports = EventDelegator;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Common = require("./../../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _tpl_user = $("#tpl-user").html(),
        _tpl_task = $("#tpl-task").html(),
        _tpl_td = $("#tpl-td").html(),
        _tpl_summary = $("#tpl-user-summary").html(),
        ud = $("#ind_usr_details");

    var $memberTasks = null,
        $taskList = null,
        $userName = null,
        $element = null,
        user = null,
        allTasksForUser = [],
        _tasks = [],
        _filteredTasks = [],
        _tasksTotal = 0,
        _tasksComplete = 0,
        _yesTasks = 0,
        _noTasks = 0,
        _html = null;

    var _resetVars = function _resetVars() {
        allTasksForUser = [];
        user = null;
        _tasks = [];
        _filteredTasks = [];
        _html = null;
        _tasksTotal = 0;
        _tasksComplete = 0;
        _noTasks = 0;
        _yesTasks = 0;

        _tpl_user = $("#tpl-user").html();
        _tpl_task = $("#tpl-task").html();
        _tpl_td = $("#tpl-td").html();
        _tpl_summary = $("#tpl-user-summary").html();
    };

    var _filterTasks = function _filterTasks(type) {
        if (Object.keys(tasks).length > 0) {
            Object.keys(tasks).forEach(function (value, index) {
                var task = tasks[value];
                var filteredTask = {};

                filteredTask.task_uid = task.task_uid;
                filteredTask.dep = task.dep;
                filteredTask.dep_abr = task.dep_abr;
                filteredTask.dep_count = task.dep_count;
                filteredTask.ftag = task.ftag;
                filteredTask.ind_uid = task.ind_uid;
                filteredTask.name = task.name;
                filteredTask.reg = task.reg;

                if (Object.keys(task['tt_tds']).length > 0) {
                    Object.keys(task['tt_tds']).forEach(function (value) {
                        var tt_td = task['tt_tds'][value];
                        var user_id = value;

                        if (Object.keys(tt_td).length > 0) {
                            Object.keys(tt_td).forEach(function (value) {

                                var td_uid = tt_td[value];
                                var tt_uid = value;
                                var yes = false,
                                    no = false,
                                    ss_yes = false,
                                    ss_no = false,
                                    completed = false,
                                    assigned = false,
                                    ss_completed = false,
                                    ss_assigned = false,
                                    is_ss = false,
                                    is_daily = false,
                                    yes_count = 0,
                                    no_count = 0,
                                    poc_avg,
                                    cms;

                                // Determine if tt is daily
                                if (task.tt_daily[user_id][tt_uid]) is_daily = true;
                                filteredTask.is_daily = is_daily;
                                filteredTask.tt_uid = tt_uid;
                                filteredTask.td_uid = td_uid;

                                // Determine if tt_td is ss
                                if (user_id in users['members']) is_ss = false;else if (user_id in users['support_services']) is_ss = true;

                                if (is_ss) {
                                    ss_assigned = true;
                                } else {
                                    assigned = true;
                                }

                                // Determine no, yes, no_count, yes_count
                                if (task.tds.length > 0) {
                                    var tdetails = task.tds.filter(function (td) {
                                        return td.uid == td_uid;
                                    });

                                    tdetails = tdetails[0];
                                    var filteredTaskNew = Object.assign({}, filteredTask);

                                    if (tdetails) {
                                        filteredTaskNew.td = tdetails;
                                        filteredTaskNew.td_uid = tdetails.uid;

                                        if (tdetails.yes.length > 0) {
                                            if (is_ss) {
                                                ss_yes = true;
                                            } else {
                                                yes = true;
                                            }
                                        }

                                        if (tdetails.no.length > 0) {
                                            if (is_ss) {
                                                ss_no = true;
                                            } else {
                                                no = true;
                                            }
                                        }

                                        if (tdetails.yes.length > 0 || tdetails.no.length > 0 || tdetails.samples.length > 0 && tdetails.SURVEY) {
                                            if (is_ss) {
                                                ss_completed = true;
                                            } else {
                                                completed = true;
                                            }
                                        } else {
                                            completed = false;
                                            ss_completed = false;
                                        }

                                        yes_count = tdetails.yes.length;
                                        no_count = tdetails.no.length;

                                        if ('POC' in tdetails) poc_avg = tdetails.POC;else if ('avg' in tdetails) poc_avg = tdetails.avg;

                                        filteredTaskNew.poc_avg = poc_avg ? poc_avg : null;

                                        if (tdetails.POC) {
                                            if (demo) cms = '<a href="/register">View</a>';else cms = '<a href="/facility/CMS2567/task/' + tdetails.uid + '">View</a>';
                                        } else {
                                            if ('SURVEY' in tdetails && tdetails.SURVEY) {
                                                if (demo) cms = '<a href="/register">View</a>';else cms = '<a href="/facility/survey/' + tdetails.uid + '">View</a>';
                                            }
                                        }
                                        filteredTaskNew.cms = cms ? cms : null;

                                        switch (type) {
                                            case 'assigned':
                                                if (assigned) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'completed':
                                                if (completed) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'yes':
                                                if (yes) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'no':
                                                if (no) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_assigned':
                                                if (ss_assigned) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_completed':
                                                if (ss_completed) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_yes':
                                                if (ss_yes) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_no':
                                                if (ss_no) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            default:
                                                break;
                                        }
                                    } else {
                                        switch (type) {
                                            case 'assigned':
                                                if (assigned) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'completed':
                                                if (completed) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'yes':
                                                if (yes) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'no':
                                                if (no) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_assigned':
                                                if (ss_assigned) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_completed':
                                                if (ss_completed) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_yes':
                                                if (ss_yes) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            case 'ss_no':
                                                if (ss_no) {
                                                    _filteredTasks.push(filteredTaskNew);
                                                };
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                } else {
                                    switch (type) {
                                        case 'assigned':
                                            if (assigned) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'completed':
                                            if (completed) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'yes':
                                            if (yes) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'no':
                                            if (no) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'ss_assigned':
                                            if (ss_assigned) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'ss_completed':
                                            if (ss_completed) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'ss_yes':
                                            if (ss_yes) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        case 'ss_no':
                                            if (ss_no) {
                                                _filteredTasks.push(filteredTask);
                                            };
                                            break;
                                        default:
                                            break;
                                    }
                                    //console.log(filteredTask);
                                }
                            });
                        }
                    });
                }
            });
        }
    };

    var _showFilteredTasks = function _showFilteredTasks(type) {
        _resetVars();
        _filterTasks(type);

        if (_filteredTasks.length == 0) {
            var blank = '\<tr>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td></tr>';
            ud.html(blank);
            return;
        }

        var title = '';

        if (type == 'ss_assigned') title = 'Assigned (Support Services)';
        if (type == 'assigned') title = 'Assigned';
        if (type == 'ss_completed') title = 'Completed (Support Services)';
        if (type == 'completed') title = 'Completed';
        if (type == 'yes') title = 'Yes';
        if (type == 'ss_yes') title = 'Yes (Support Services)';
        if (type == 'no') title = 'No';
        if (type == 'ss_no') title = 'No (Support Services)';

        var memberNameHTML = title;
        ud.html(_tpl_user).find('.user-name').html(memberNameHTML);

        _filteredTasks.forEach(function (task) {

            if (typeof task === 'undefined') return true;

            _tpl_user = $("#tpl-user").html();
            _tpl_task = $("#tpl-task").html();
            _tpl_td = $("#tpl-td").html();
            _tpl_summary = $("#tpl-user-summary").html();

            _tasksTotal++;

            if (task.ftag == 'null' || task.ftag == null || typeof task.ftag === 'undefined') task.ftag = '';

            _tpl_task = _tpl_task.replace('{task_uid}', task.task_uid);
            _tpl_task = _tpl_task.replace('{dep_abr}', task.dep_abr);
            _tpl_task = _tpl_task.replace('{dep}', task.dep);
            _tpl_task = _tpl_task.replace('{dep_count}', task.dep_count);
            _tpl_task = _tpl_task.replace('{ftag}', task.ftag);
            _tpl_task = _tpl_task.replace('{reg}', task.reg);
            _tpl_task = _tpl_task.replace('{name}', task.name);
            _tpl_task = _tpl_task.replaceAllRegExp('{is_daily}', task.is_daily ? 'daily' : '');
            _tpl_task = _tpl_task.replaceAllRegExp('{ind_uid}', task.ind_uid);

            var url = void 0;
            if (demo) {
                url = '/register';
            } else {
                if (typeof task.td_uid !== 'undefined' && task.td_uid !== null) {
                    url = '/facility/indicators?td=' + task.td_uid;
                } else {
                    url = '/facility/indicators?tt=' + task.tt_uid;
                }
            }
            _tpl_task = _tpl_task.replace('{task_url}', url);
            ud.find('table').append(_tpl_task);

            if (task.td_uid != null && typeof task.td !== 'undefined') {

                if (task.td.yes.length > 0 && task.td.no.length == 0) _yesTasks++;else _noTasks++;

                // columns for TD (if provided)
                _tpl_td = _tpl_td.replace('{yes}', 'SURVEY' in task.td && task.td.SURVEY ? '' : task.td.yes.length);
                _tpl_td = _tpl_td.replace('{no}', 'SURVEY' in task.td && task.td.SURVEY ? '' : task.td.no.length);

                _tpl_td = _tpl_td.replace('{poc_avg}', task.poc_avg != null ? task.poc_avg : '');
                _tpl_td = _tpl_td.replace('{cms}', task.cms != null ? task.cms : '');
                _tpl_td = _tpl_td.replace('{uid}', task.td_uid);

                var completed = '';
                if (demo) url = '/register';else url = '/facility/indicators?td=' + task.td_uid;

                if (task.td.yes.length > 0 || task.td.no.length > 0 || task.td.samples.length > 0 && task.td.SURVEY) {
                    _tasksComplete++;
                    completed = '<a style="vertical-align: middle;" href="' + url + '" class="indDate" data-task="' + task.task_uid + '">' + task.td.date + '</a>';
                } else {
                    completed = '<a style="vertical-align: middle;" href="' + url + '" class="indDate" data-task="' + task.task_uid + '">INCOMPLETE</a>';
                }
                _tpl_td = _tpl_td.replace('{completed}', completed);
                _tpl_td = _tpl_td.replaceAllRegExp('{task_url}', url);
                _tpl_td = _tpl_td.replaceAllRegExp('{tt_uid}', task.tt_uid);
                _tpl_td = _tpl_td.replaceAllRegExp('{is_daily}', task.is_daily ? 'daily' : '');

                ud.find('table tr:last').append(_tpl_td);
            } else {

                if (demo) url = '/register';else url = '/facility/indicators?tt=' + task.tt_uid;
                var inc_html = '\
              <td class="alignCenter ' + (task.is_daily ? 'daily' : '') + '" style="padding-top:3px;">0</td>\
              <td class="alignCenter ' + (task.is_daily ? 'daily' : '') + '" style="padding-top:3px;">0</td>\
              <td class="alignCenter ' + (task.is_daily ? 'daily' : '') + '" style="padding-top:3px;"></td>\
              <td class="alignCenter ' + (task.is_daily ? 'daily' : '') + '" style="padding-top:3px;"></td>\
              <td class="' + (task.is_daily ? 'daily' : '') + '" style="padding-top:3px;position:relative;"><a href="' + url + '">INCOMPLETE</a>\
              \ <div style="position: absolute; right: 4px; top: 7px;">\
                  <a href="#" class="indicatorDatePicker" data-tt="' + task.tt_uid + '"><img src="/assets/images/calendar-icon.png" width="16" style="padding-left: 4px; outline: 0 !important;vertical-align:middle;" /></a>\
                  <a href="#" class="deleteTT" data-tt="' + task.tt_uid + '"><img src="/assets/images/close-x.png" width="14" style="padding-left: 2px; outline: 0 !important;vertical-align:middle;" /></a>\
                  <input type="hidden" value="{uid}" class="td_uid"/>\
                  <input type="text" style="height: 0px; width:1px; border: 0px; display: block; padding: 0px !important;" class="datepicker"/>\
              </div>\
              </td>\
              ';

                // columns for TD if not completed yet
                ud.find('table tr:last').append(inc_html);
            }

            // close the row
            ud.find('table').append('</tr>');
        });

        var yesCompliance = Math.round(_yesTasks / _tasksTotal * 100);
        var noCompliance = Math.round(_noTasks / _tasksTotal * 100);
        var tasksComplete = Math.round(_tasksComplete / _tasksTotal * 100);

        _tpl_summary = _tpl_summary.replace('{yesCompliance}', isNaN(yesCompliance) ? 0 : yesCompliance);
        _tpl_summary = _tpl_summary.replace('{noCompliance}', isNaN(noCompliance) ? 0 : noCompliance);
        _tpl_summary = _tpl_summary.replace('{tasksComplete}', isNaN(tasksComplete) ? 0 : tasksComplete);

        $(document).off('click', '.ftag, .reg, .ind_name').on('click', '.ftag, .reg, .ind_name', function () {
            var task_dep = $(this).parent().attr('data-dep');
            window.location.href = "/facility/dashboard/" + task_dep;
        });

        ud.find('table').append(_tpl_summary);
        _html = ud.html();
    };

    //_showFilteredTasks('yes');


    var _showUserTasks = function _showUserTasks(user_id) {
        _resetVars();
        user = user_id in users.members ? users.members[user_id] : users.support_services[user_id];
        var memberName = user.first_name + " " + user.last_name,
            link = demo == 1 ? '/register' : "/facility/CMS2567/user/" + user_id + "?start=" + start + "&amp;end=" + end;
        if (dep != 'all' && !demo) {
            link = link + '&amp;dep=' + dep;
        }
        var memberNameHTML = memberName + ("<a href=\"" + link + "\" id=\"mag_icon\"><img src=\"/assets/images/magnifying-glass-hi.png\"></a>"),
            utasks = [];
        if (dep === 'all') {
            if (!demo) {
                for (var i = 2; i <= 8; i++) {
                    utasks = utasks.concat(userTasks[i][user_id]);
                }
            } else {
                utasks = utasks.concat(userTasks[2][user_id]);
            }
        } else {
            utasks = userTasks[dep][user_id];
        }

        ud.html(_tpl_user).find('.user-name').html(memberNameHTML);
        if (utasks.length == 0) {
            var blank = '\<tr>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td>\
            <td class="alignCenter" style="padding-top:3px;"></td></tr>';
            ud.html(blank);
            return;
        }

        utasks.forEach(function (val) {
            if (typeof val === 'undefined') return true;

            _tpl_user = $("#tpl-user").html();
            _tpl_task = $("#tpl-task").html();
            _tpl_td = $("#tpl-td").html();
            _tpl_summary = $("#tpl-user-summary").html();

            _tasksTotal++;
            var task_id = val.split('.')[0],
                index = val.split('.')[1],
                task = tasks[task_id],
                td = task.tt_tds[user_id][Object.keys(tasks[task_id].tt_tds[user_id])[index]],
                date = task.tt_dates[user_id][Object.keys(tasks[task_id].tt_dates[user_id])[index]],
                tt_uid = Object.keys(tasks[task_id].tt_dates[user_id])[index],
                is_daily = 'tt_daily' in tasks[task_id] ? tasks[task_id].tt_daily[user_id][tt_uid] : false,

            //tdetails = task.tds[index];
            tdetails = null;
            tasks[task_id].tds.forEach(function (v) {
                if (v.uid === td) {
                    tdetails = v;
                    return true;
                }
            });
            if (task.ftag == 'null' || task.ftag == null || typeof task.ftag === 'undefined') task.ftag = '';
            // basic row columns
            _tpl_task = _tpl_task.replace('{task_uid}', task_id);
            _tpl_task = _tpl_task.replace('{dep_abr}', task.dep_abr);
            _tpl_task = _tpl_task.replace('{dep}', task.dep);
            _tpl_task = _tpl_task.replace('{dep_count}', task.dep_count);
            _tpl_task = _tpl_task.replace('{ftag}', task.ftag);
            _tpl_task = _tpl_task.replace('{reg}', task.reg);
            _tpl_task = _tpl_task.replace('{name}', task.name);
            _tpl_task = _tpl_task.replaceAllRegExp('{is_daily}', is_daily ? 'daily' : '');
            _tpl_task = _tpl_task.replaceAllRegExp('{ind_uid}', task.ind_uid);
            if (td != null && typeof tdetails !== 'undefined' && !demo) var url = '/facility/indicators?td=' + tdetails.uid + '&back=' + user_id;else if (!demo) var url = '/facility/indicators?tt=' + tt_uid + '&back=' + user_id;
            if (demo) var url = '/register';
            _tpl_task = _tpl_task.replace('{task_url}', url);
            ud.find('table').append(_tpl_task);
            if (td != null && typeof tdetails !== 'undefined') {

                // if (!('yes' in tdetails) || !('no' in tdetails) || typeof tdetails.yes != 'object' || typeof tdetails.no != 'object'
                //     || !tdetails.yes || !tdetails.no || tdetails.yes == null || tdetails.no == null)
                // {
                //     console.log('Missing yes/no');
                //     tdetails.yes = [];
                //     tdetails.no = [];
                // }

                if (!('yes' in tdetails) || _typeof(tdetails.yes) !== 'object' || !tdetails.yes || tdetails.yes === null) tdetails.yes = [];
                if (!('no' in tdetails) || _typeof(tdetails.no) !== 'object' || !tdetails.no || tdetails.no === null) tdetails.no = [];

                if (tdetails.yes.length > 0 && tdetails.no.length == 0) _yesTasks++;else _noTasks++;

                // columns for TD (if provided)
                _tpl_td = _tpl_td.replace('{yes}', 'SURVEY' in tdetails && tdetails.SURVEY ? '' : tdetails.yes.length);
                _tpl_td = _tpl_td.replace('{no}', 'SURVEY' in tdetails && tdetails.SURVEY ? '' : tdetails.no.length);

                var poc_avg = '';
                if ('POC' in tdetails) poc_avg = tdetails.POC;else if ('avg' in tdetails) poc_avg = tdetails.avg;

                if (poc_avg == false) poc_avg = '';

                _tpl_td = _tpl_td.replace('{poc_avg}', poc_avg);

                // CMS
                var cms = '';
                if (tdetails.POC) {
                    if (demo) cms = '<a href="/register">View</a>';else cms = '<a href="/facility/CMS2567/task/' + tdetails.uid + '">View</a>';
                } else {
                    if ('SURVEY' in tdetails && tdetails.SURVEY) {
                        if (demo) cms = '<a href="/register">View</a>';else cms = '<a href="/facility/survey/' + tdetails.uid + '">View</a>';
                    }
                }

                _tpl_td = _tpl_td.replace('{cms}', cms);
                _tpl_td = _tpl_td.replace('{uid}', tdetails.uid);

                // COMPLETED
                var completed = '';
                if (demo) var url = '/register';else var url = '/facility/indicators?td=' + tdetails.uid + '&back=' + user_id;

                if (tdetails.yes.length > 0 || tdetails.no.length > 0 || tdetails.samples.length > 0 && tdetails.SURVEY) {
                    _tasksComplete++;
                    completed = '<a style="vertical-align: middle;" href="' + url + '" class="indDate" data-task="' + tdetails.task_uid + '">' + tdetails.date + '</a>';
                } else {
                    completed = '<a style="vertical-align: middle;" href="' + url + '" class="indDate" data-task="' + tdetails.task_uid + '">INCOMPLETE</a>';
                }
                _tpl_td = _tpl_td.replace('{completed}', completed);
                _tpl_td = _tpl_td.replaceAllRegExp('{task_url}', url);
                _tpl_td = _tpl_td.replaceAllRegExp('{tt_uid}', tt_uid);
                _tpl_td = _tpl_td.replaceAllRegExp('{is_daily}', is_daily ? 'daily' : '');

                ud.find('table tr:last').append(_tpl_td);
            } else {
                //console.log(task);

                if (demo) var url = '/register';else var url = '/facility/indicators?tt=' + tt_uid + '&back=' + user_id;
                var inc_html = '\
                  <td class="alignCenter ' + (is_daily ? 'daily' : '') + '" style="padding-top:3px;">0</td>\
                  <td class="alignCenter ' + (is_daily ? 'daily' : '') + '" style="padding-top:3px;">0</td>\
                  <td class="alignCenter ' + (is_daily ? 'daily' : '') + '" style="padding-top:3px;"></td>\
                  <td class="alignCenter ' + (is_daily ? 'daily' : '') + '" style="padding-top:3px;"></td>\
                  <td class="' + (is_daily ? 'daily' : '') + '" style="padding-top:3px;position:relative;"><a href="' + url + '">INCOMPLETE</a>\
                  \ <div style="position: absolute; right: 4px; top: 7px;">\
                      <a href="#" class="indicatorDatePicker" data-tt="' + tt_uid + '"><img src="/assets/images/calendar-icon.png" width="16" style="padding-left: 4px; outline: 0 !important;vertical-align:middle;" /></a>\
                      <a href="#" class="deleteTT" data-tt="' + tt_uid + '"><img src="/assets/images/close-x.png" width="14" style="padding-left: 2px; outline: 0 !important;vertical-align:middle;" /></a>\
                      <input type="hidden" value="{uid}" class="td_uid"/>\
                      <input type="text" style="height: 0px; width:1px; border: 0px; display: block; padding: 0px !important;" class="datepicker"/>\
                  </div>\
                  </td>\
                  ';

                // columns for TD if not completed yet
                ud.find('table tr:last').append(inc_html);
            }

            // close the row
            ud.find('table').append('</tr>');
        });

        var yesCompliance = Math.round(_yesTasks / _tasksTotal * 100);
        var noCompliance = Math.round(_noTasks / _tasksTotal * 100);
        var tasksComplete = Math.round(_tasksComplete / _tasksTotal * 100);

        _tpl_summary = _tpl_summary.replace('{yesCompliance}', isNaN(yesCompliance) ? 0 : yesCompliance);
        _tpl_summary = _tpl_summary.replace('{noCompliance}', isNaN(noCompliance) ? 0 : noCompliance);
        _tpl_summary = _tpl_summary.replace('{tasksComplete}', isNaN(tasksComplete) ? 0 : tasksComplete);

        $(document).off('click', '.ftag, .reg, .ind_name').on('click', '.ftag, .reg, .ind_name', function () {
            var task_dep = $(this).parent().attr('data-dep');
            window.location.href = "/facility/dashboard/" + task_dep;
        });

        ud.find('table').append(_tpl_summary);
        _html = ud.html();
    };

    var demoRedirect = function demoRedirect(e) {
        e.preventDefault();
        window.location.href = '/login';
    };

    var init = function init() {
        _tasks = [];
        allTasksForUser = [];
        $('.filter').click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#ind_usr_details").offset().top
            }, 300);
            var type = $(this).data('type'),
                is_ss = $(this).data('member-type');

            if (is_ss == "ss") type = 'ss_' + type;
            _showFilteredTasks(type);
        });
        $userName = $('.user_details .underline:not(.email), .user_details .indMonthTable');
        if (demo) {
            _showUserTasks(1);
            $userName.parent().click(demoRedirect);
        } else {
            $userName.parent().click(function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $("#ind_usr_details").offset().top
                }, 300);
                _showUserTasks($(this).parent().attr('rel'));
                return false;
            });
            $userName.click(function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $("#ind_usr_details").offset().top
                }, 300);
                _showUserTasks($(this).parent().parent().attr('rel'));
                return false;
            });
            $('.user_details .trigger_email').click(function (e) {
                $(this).find('a')[0].click();
            });
            if (openedUser != 'false' && parseInt(openedUser)) {
                $(".user_details[rel=\"" + openedUser + "\"]").children().eq(0).click();
            }
        }
    };

    var getUser = function getUser() {
        return user;
    };

    var getHTML = function getHTML(user_uid) {
        $('.has_poc_letter[rel="' + user_uid + '"] .metric_detail:eq(0)').click();
        var html = _html;
        ud.empty();
        return html;
    };

    return {
        init: init,
        getUser: getUser,
        getHTML: getHTML
    };
}();

},{"./../../Common":2}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require('./Common');

var _Common2 = _interopRequireDefault(_Common);

var _EventDelegator = require('./EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SEDatePicker = function () {
	function SEDatePicker($start, $end, goButton) {
		var minMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

		_classCallCheck(this, SEDatePicker);

		var defaultDatePickerOptions = {
			dateFormat: "MM d, yy",
			changeMonth: true
		};
		if (minMax) {
			defaultDatePickerOptions.onClose = function (selectedDate, instance) {
				$('#' + (instance.id === 's' ? 'e' : 's')).datepicker('option', instance.id === 's' ? 'minDate' : 'maxDate', selectedDate);
			};
		}
		//create the default date pickers
		this.start = $start.datepicker(defaultDatePickerOptions);
		this.end = $end.datepicker(defaultDatePickerOptions);
		this.goButton = document.getElementById(goButton);
		this._goFunction = function (event) {
			event = event || window.event;
			event.preventDefault();
			var appendData = {
				start: _Common2.default.URLFormatter.formatDatePicker(this.start.val()),
				end: _Common2.default.URLFormatter.formatDatePicker(this.end.val())
			};
			_EventDelegator2.default.emit('SEDatePickerGo', appendData);
			window.location.href = _Common2.default.URLFormatter.formatGetObject(this._goURL, appendData);
			return false;
		}.bind(this);
		this.goButton.addEventListener('click', this._goFunction);
		this._goURL = window.location.href;
		return this;
	}

	_createClass(SEDatePicker, [{
		key: 'getDates',
		value: function getDates() {
			var s = this.start.datepicker('getDate'),
			    e = this.end.datepicker('getDate');
			return [s, e];
		}
	}, {
		key: 'getFormattedDates',
		value: function getFormattedDates() {
			var s = _Common2.default.URLFormatter.formatDatePicker(this.start.val()),
			    e = _Common2.default.URLFormatter.formatDatePicker(this.end.val());
			return [s, e];
		}
	}, {
		key: 'goFunction',
		set: function set(func) {
			this.goButton.removeEventListener('click', this._goFunction);
			this._goFunction = func.bind(this);
			this.goButton.addEventListener('click', this._goFunction);
		}
	}, {
		key: 'goURL',
		set: function set(url) {
			this._goURL = url;
		}
	}]);

	return SEDatePicker;
}();
//TODO FIX DATE EITHER GOING ONE TO FAR OR ONE TO EARLY


exports.default = SEDatePicker;

},{"./Common":2,"./EventDelegator":12}],15:[function(require,module,exports){
'use strict';

var _Common = require('./es6/Common');

var _Common2 = _interopRequireDefault(_Common);

var _EventDelegator = require('./es6/EventDelegator');

var _EventDelegator2 = _interopRequireDefault(_EventDelegator);

var _SEDatePicker = require('./es6/SEDatePicker');

var _SEDatePicker2 = _interopRequireDefault(_SEDatePicker);

var _UserTasks = require('./es6/Facility/Compliance/UserTasks');

var _UserTasks2 = _interopRequireDefault(_UserTasks);

var _API = require('./es6/API');

var _API2 = _interopRequireDefault(_API);

var _DatePicker = require('./es6/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
	var SEDatePickers = new _SEDatePicker2.default($('#s'), $('#e'), 'setDates');
	_UserTasks2.default.init();

	var DatePickers = new _DatePicker2.default('.indicatorDatePicker', { useEventDelegator: true });
	var departments = [],
	    professions = [],
	    departmentsFormatted = {};

	var loadedDates = function loadedDates(request) {
		var $datepicker = this.$datepicker;
		var avalibleDates = JSON.parse(request.responseText);
		DatePickers.avalibleDates = avalibleDates;
		var defaultDate = new Date($datepicker.siblings('.indDate').text());
		$datepicker.datepicker('setDate', defaultDate);
		$(".ui-datepicker-prev, .ui-datepicker-next").remove();
		$datepicker.datepicker('show');
	};

	var clickDatepicker = function clickDatepicker($datepicker) {
		var curUser = _UserTasks2.default.getUser();

		// console.log(curUser);

		// if(typeof curUser === null){
		//     popUpMsg('To make modifications please <a href="/register">register</a>.');
		//     return;
		// }

		_API2.default.call('user/loggedIn', 'POST', { user: curUser['uid'], start: start, end: end }, 'getDates');
		_EventDelegator2.default.on('ajaxSuccess.getDates', loadedDates.bind({ $datepicker: $datepicker }));
		//EventDelegator.on('failCallback', failCallback);
	};

	_EventDelegator2.default.on('DatePicker.click', clickDatepicker);

	var selectDatepicker = function selectDatepicker(data) {
		var curUser = _UserTasks2.default.getUser();
		_API2.default.call('td/setDate', 'POST', { uid: data.dateObj.input.prev().val(), user: curUser['uid'], date: data.date, start: start, end: end }, 'recievedDates');
		_EventDelegator2.default.on('ajaxSuccess.recievedDates', setDate.bind({ data: data }));
	};

	var setDate = function setDate(request) {
		this.data.dateObj.input.parent().parent().children('.indDate').text(this.data.date);
		this.data.dateObj.input.datepicker('hide').promise().done(function () {
			this.data.dateObj.input.datepicker('destroy');
		}.bind(this));
	};

	var showHover = function showHover(event) {
		if (event.type === 'mouseenter') {
			var that = $(this);
			var ind_uid = $(this).attr('rel');
			var content = $(this).attr('data-content');
			if (!content) {
				$(that).next('.defPop').css('display', 'block').stop().animate({
					'opacity': 1
				}, 300);
				var doneFunction = function doneFunction(data, status, xhr) {
					if (data == 'FORBIDDEN') {
						$(that).next('.defPop').addClass('popup_hidden');
						var html = '<p style="font-size: 16px !important; text-align: center; font-weight: bold;">Thank you for your understanding</p>\
								    <p>&nbsp;</p>\
									<p style="text-align:center;"><strong>Indicator Views are limited for unregistered users.</strong></p><p style="text-align:center;"><strong>For unrestricted access to SNFQAPI.com please <a href="/register">register here.</a></strong></p>\
		  							<p>&nbsp;</p>\
								    <p style="font-size: 12px !important; text-align: center; font-weight: normal;">INDICATORS are protected by copyright and are the property of SNFQAPI, LLC</p>';
						$('.ind_content_' + ind_uid).html(html);
					} else {
						$('.ind_content_' + ind_uid).html(data);
					}
				};
				apiAjaxCall('indicators/popup/' + ind_uid, 'GET', {}, { dataType: 'html' }, false, doneFunction);
			} else {
				$(that).next('.defPop').find('p .pop-content').empty().html(content);
				$(that).next('.defPop').css('display', 'block').stop().animate({
					'opacity': 1
				}, 300);
			}
		} else {
			$('.defPop').stop().animate({
				'opacity': 0
			}, 200, function () {
				$(this).css('display', 'none');
			});
		}
	};

	$(document).on('mouseenter mouseleave', '.showRegPop', showHover);
	$(document).on('click', '.topRight, .indicator_desc_close', function () {
		$(this).parent().parent().stop().animate({
			'opacity': 0
		}, 300, function () {
			$(this).css('display', 'none');
		});
	});

	var buildProfessionDepartment = function buildProfessionDepartment() {
		departmentsFormatted = {};
		$.each(departments, function (index, department) {
			department.professions = [];
			departmentsFormatted[department.uid] = department;
		});
		$.each(professions, function (prof_uid, profession) {
			$.each(departmentsFormatted, function (dep_uid, department) {
				if ($.inArray(dep_uid, profession.default_departments) != -1) {
					departmentsFormatted[dep_uid].professions.push(profession.title);
				}
			});
		});
	};
	var getDepProf = function getDepProf(callback) {
		callback = typeof callback === 'undefined' ? function () {} : callback;
		$.getJSON('/api/v1/professions', function (data) {
			professions = data.professions;
			departments = data.departments;
			callback();
		});
	};

	var splitArray = function splitArray(a, n) {
		var len = a.length,
		    out = [],
		    i = 0;
		while (i < len) {
			var size = Math.ceil((len - i) / n--);
			out.push(a.slice(i, i += size));
		}
		return out;
	};

	getDepProf();
	$('.indicator-category-title').click(function (e) {
		e.preventDefault();
		buildProfessionDepartment();
		if ($(this).data('open') == 'false' || typeof $(this).data('open') === 'undefined') {
			$('.indicator-category-title').data('open', 'false');
			$('.indicator-category-professions-div').animate({
				opacity: 0
			}, 300, function () {
				$(this).remove();
			});
			$(this).parent().css('position', 'relative');
			var html = '<div class="indicator-category-professions-div ' + ($(this).hasClass('title-top') ? 'title-top' : '') + '">';
			html += '<p style="position: relative;"><strong>' + departmentsFormatted[$(this).attr('rel')].name + '</strong><span style="display: block; position: absolute; right: 10px; top: 6px;"><i class="icon-cancel-circled" data-icon="i" style="font-size: 20px;"></i></span></p>';
			departmentsFormatted[$(this).attr('rel')].professions.sort();
			var columnsFormatted = splitArray(departmentsFormatted[$(this).attr('rel')].professions, 3);
			for (var c = 0; c < columnsFormatted.length; c++) {
				html += '<ul class="align_left" style="display: inline-block; width: 33%;margin: 0px auto;">';
				for (var i = 0; i < columnsFormatted[c].length; i++) {
					html += '<li style="font-size: 12px; margin: 10px 0;">' + columnsFormatted[c][i] + '</li>';
				}
				html += '</ul>';
			}
			html += '</div>';
			$(html).css('opacity', '0').appendTo(this).animate({
				opacity: 1
			}, 200);
			$(this).data('open', 'true');
		} else if ($(this).data('open') == 'true') {
			$('.indicator-category-title').data('open', 'false');
			$('.indicator-category-professions-div').animate({
				opacity: 0
			}, 200, function () {
				$(this).remove();
			});
		}
		return false;
	});

	_EventDelegator2.default.on('DatePicker.onSelect', selectDatepicker);

	$(document).on('click', '.deleteTT', function (e) {
		if (e) e.preventDefault();
		var $this = $(this);
		_API2.default.setMultipleCalls(true);
		window.popUpConfMsg('Are you sure you want to remove this indicator assignment?', function () {
			if (demo) $this.parent().parent().parent().remove();else {
				_API2.default.handle('tt/' + $this.attr('data-tt'), 'POST', { _method: 'delete' }, 'save', true).then(function (success) {
					if (success.data == 'success') window.location.reload();else window.unknownError();
				}).catch(function (fail) {
					if (fail.data == 'fail') window.popUpMsg('You do not have the permissions to delete this assignment.');
				});
			}
		});

		return false;
	});

	//LEGACY
	$('#ss_letters span.underline').click(function (e) {
		e.preventDefault();
		if (demo) window.location.href = '/login';
		var selected_letter = $(this).attr('rel');
		var user_ids = [];
		var memberType = $(this).closest('table[data-member-type]').data('member-type');

		$('.table_row').removeClass('has_poc_letter');

		$('.table_row[data-member-type="' + memberType + '"]').each(function () {
			var letters = $(this).attr('data-letters');
			if (letters != undefined && letters.indexOf(selected_letter) >= 0) {
				$(this).addClass('has_poc_letter');
				user_ids.push($(this).attr('id'));
			}
		});

		$('#ind_usr_details').html('');

		var html = '';
		for (var i = 0; i < user_ids.length; i++) {

			var tmp_id = user_ids[i].replace('ind_row_', '');

			html += _UserTasks2.default.getHTML(tmp_id) + '<br /><br />';
		}
		$('#ind_usr_details').html(html);

		window.scroll(0, parseInt($('#ind_usr_details').position().top) + 210);
	});
	$('.tooltip').tooltipster();
});

},{"./es6/API":1,"./es6/Common":2,"./es6/DatePicker":11,"./es6/EventDelegator":12,"./es6/Facility/Compliance/UserTasks":13,"./es6/SEDatePicker":14}]},{},[15]);
